<script setup>
    import { WrenchScrewdriverIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <WrenchScrewdriverIcon />
</template>
